import {
  START_UPLOAD_ATTACHMENT,
  END_UPLOAD_ATTACHMENT,
  ADD_ATTACHMENT_REQUEST,
  REMOVE_ATTACHMENT,
  GET_SIGNED_URL,
  GET_SIGNED_URL_SUCCESS,
  GET_SIGNED_URL_FAIL,
  UPLOAD_TO_S3,
  UPLOAD_TO_S3_SUCCESS,
  UPLOAD_TO_S3_FAIL,
  INITIALIZE_ATTACHMENTS,
  AttachmentsAction,
} from "./actionTypes";
import { matchUnsafeS3Chars } from "../../../utils/regex";
import { AsyncAction } from "../../store";

// Toggles the upload form popup
export function startUploadAttachment(): AttachmentsAction {
  return { type: START_UPLOAD_ATTACHMENT };
}

export function endUploadAttachment(): AttachmentsAction {
  return { type: END_UPLOAD_ATTACHMENT };
}

// Resets attachments store to initial empty state
export function resetAttachmentState(): AttachmentsAction {
  return { type: INITIALIZE_ATTACHMENTS };
}

// Handles preparing attachment for upload; includes retrieve pre-signed url for upload
export function handleAddAttachment(attachment: any): AttachmentsAction {
  return { type: ADD_ATTACHMENT_REQUEST, attachment };
}

// Remove attachment from list of attachments to upload
export function handleRemoveAttachment(attachment: any): AttachmentsAction {
  return { type: REMOVE_ATTACHMENT, attachment };
}

export function getSignedUrl(
  user: any,
  issueId: string,
  fileName = "",
  fileType: string
): AsyncAction {
  // Replace unsafe filename characters with `-`
  const safeFileName = fileName.replace(matchUnsafeS3Chars, "-");
  return {
    types: [GET_SIGNED_URL, GET_SIGNED_URL_SUCCESS, GET_SIGNED_URL_FAIL],
    promise: (client) =>
      client.get(`/upload/${issueId}/${safeFileName}`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        params: {
          content_type: fileType,
        },
      }),
  };
}

export function uploadToS3(signedUrl: string, file: any): AsyncAction {
  return {
    types: [UPLOAD_TO_S3, UPLOAD_TO_S3_SUCCESS, UPLOAD_TO_S3_FAIL],
    promise: (client) =>
      client.put(
        signedUrl,
        {
          data: file,
        },
        { externalPath: true }
      ),
  };
}
